import ContractsList from "../../Contracts/ContractsList/ContractsList";

export const ContractsListTab = (props) => (
  <>
    <ContractsList {...props} />
  </>
);
